import React from "react";
import ProductService from "../services/product.service";
import ListProducts from "../components/lists/ListProducts";
import {CButton, CCard, CCardBody, CCol, CContainer, CForm, CFormInput, CFormSelect, CSpinner} from "@coreui/react";
import {StateContext} from "../components/context/StateProvider";
import ProductFactory from "../models/ProductFactory";
import AlmacenesService from "../services/almacenes.service";
import {generarSelectorAlmacenes} from "../utils/TransformadorDatos";

class Stock extends React.Component {

    static contextType = StateContext;

    constructor(props) {
        super(props);
        this.state = {thresholdFrom: '', thresholdTo: '', almacenes: [], almacenSeleccionado: "0"};
    }

    async componentDidMount() {
        const almacenes = await AlmacenesService.obtenerAlmacenes(false);
        this.setState({almacenes: generarSelectorAlmacenes(almacenes)});
    }

    handleChange(event, type) {
        this.setState({[type]: event.target.value});
    }

    async handleSubmit(event) {

        if (event) {
            event.preventDefault();
        }

        const {updateState} = this.context;

        updateState({products: []})
        if (this.state.value !== "") {

            updateState({loading: true});

            await ProductService.getStockGeneralProducts(this.state.almacenSeleccionado, this.state.thresholdFrom, this.state.thresholdTo).then(
                async (data) => {
                    const productMap = data.map(async (product) => {

                        return ProductFactory.product(product.CODIGO,
                            product.BarrasModels,
                            product.NOMBRE,
                            product.UBICACION,
                            product.VENSERIE,
                            product.Art_FotoModels,
                            product.MulticamModels,
                            product.Stocks2Models,
                            product.REPONER
                        );
                    });

                    const productsMapFull = await Promise.all(productMap);

                    updateState({products: productsMapFull})
                    updateState({loading: false});
                }
            );
        }
    }

    componentWillUnmount() {
        const {updateState} = this.context;
        updateState({toasts: []})
        updateState({products:[]});
    }

    handleChangeAlmacen = (event) => {
        this.setState({almacenSeleccionado: event.target.value});
    }

    render() {

        const {state} = this.context;

        return (
            <CCol id="stock" md={12}>
                <CCard className="p-3">
                    <CCardBody>
                        <CForm onSubmit={(e) => this.handleSubmit(e)} className="mb-3">
                            <div className="mb-3">
                                <label htmlFor="threshold-from" className="form-label">Stock desde</label>
                                <CFormInput className="form-control" type="text" id="threshold-from" name="threshold-from"
                                       value={this.state.thresholdFrom}
                                       onChange={(e) => this.handleChange(e, 'thresholdFrom')}/>
                                <label htmlFor="threshold-to" className="form-label mt-2">Stock hasta</label>
                                <CFormInput className="form-control" type="text" id="threshold-to" name="threshold-to"
                                            value={this.state.thresholdTo}
                                            onChange={(e) => this.handleChange(e, 'thresholdTo')}/>
                                <label htmlFor="warehouse" className="form-label mt-2">Almacen</label>
                                <CFormSelect className='form-control mb-2'
                                             onChange={(e) => this.handleChangeAlmacen(e)}
                                             id="warehouse"
                                             name="warehouse"
                                             aria-label="Seleccionar almacen"
                                             options={this.state.almacenes}/>
                            </div>
                            <CButton type="submit" color="primary" className="px-4 col-12">
                                {state.loading ?
                                    <CSpinner component="span" size="sm"
                                              aria-hidden="true"/> : 'Buscar'}
                            </CButton>
                        </CForm>
                        <ListProducts updateProducts="1" selectProducts="1"/>
                    </CCardBody>
                </CCard>
            </CCol>
        );
    }
}

export default Stock;